import React, { Component } from 'react';
import './LinkAccount.css';

import Title from '../ui/Title.js';
import BodyText from '../ui/BodyText.js';
import FormError from '../ui/FormError.js';
import FormInput from '../ui/FormInput.js';
import DisabledFormInput from '../ui/DisabledFormInput.js';
import HelpLink from '../ui/HelpLink.js';
import Button from '../ui/Button.js';
import SmallText from '../ui/SmallText.js';
import Loading from '../ui/Loading.js';

class LinkAccount extends Component {

  render() {

    return (
      <div className = "LinkAccount">
        <Title
          label = {this.props.translationService.get('linkaccount.title')}
          onClose = {this.props.onClose}
          />
        <BodyText
          text = {this.props.translationService.get('linkaccount.bodytext', {openIdProvider: this.props.provider})}
          />
        <FormError
          text = {this.props.formError}
          />
        <DisabledFormInput
          label = {this.props.translationService.get('form.email.label')}
          value = {this.props.emailValue}
        />
        <FormInput
          type = 'password'
          label = {this.props.translationService.get('form.password.label')}
          value = {this.props.passwordValue}
          errorMessage = {this.props.passwordErrorMessage}
          onChange = {this.props.onPasswordChange}
        />
        <HelpLink
          text = {this.props.translationService.get('form.forgotpassword.label')}
          onClick = {this.props.onPasswordHelpClick}
        />
        {this.props.actionInProgress ? (
          <Loading/>
        ) : (
          <Button
            label = {this.props.translationService.get('actions.linkaccount')}
            onClick = {this.props.onButtonClick}
            />
        )}
        <SmallText
          text = {this.props.translationService.get('captureemail.smalltext')}
          />
      </div>
    );

  }

}

export default LinkAccount;



// WEBPACK FOOTER //
// ./src/comps/LinkAccount.js